import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background/70 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-302">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-303">
        <a href="#" className="text-2xl font-bold tracking-tighter text-white" data-id="element-304">
          Website
          <span className="text-gradient bg-gradient-to-r from-electric to-cyan" data-id="element-305">
            IA
          </span>
        </a>

        <div className="hidden md:flex items-center space-x-8" data-id="element-306">
          <a href="#beneficios" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-307">
            Beneficios
          </a>
          <a href="#industrias" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-308">
            Industrias
          </a>
          <a href="#proceso" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-309">
            Proceso
          </a>
        </div>

        <div className="hidden md:block" data-id="element-310">
          <a href="https://wa.me/59898838657?text=%C2%A1Hola%21%20Quiero%20activar%20mi%20web%20premium%20con%20WebsiteIA.%20%C2%BFMe%20asesoran%3F" target="_blank" rel="noreferrer" className="relative inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white transition-all duration-300 bg-white/5 border border-white/10 rounded-full hover:bg-white/10 hover:border-white/20 hover:shadow-[0_0_20px_rgba(168,85,247,0.4)] group" data-id="element-311">
            <span className="relative z-10" data-id="element-312">Activar mi web</span>
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-electric/20 to-cyan/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-md" data-id="element-313"></div>
          </a>
        </div>

        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-314">
          {mobileMenuOpen ? <XIcon size={24} data-id="element-315" /> : <MenuIcon size={24} data-id="element-316" />}
        </button>
      </div>

      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 right-0 bg-background/95 backdrop-blur-xl border-b border-white/10 p-6 flex flex-col space-y-6 md:hidden" data-id="element-317">
          <a href="#beneficios" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-neutral-300" data-id="element-318">
            Beneficios
          </a>
          <a href="#industrias" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-neutral-300" data-id="element-319">
            Industrias
          </a>
          <a href="#proceso" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-neutral-300" data-id="element-320">
            Proceso
          </a>
          <a href="https://wa.me/59898838657?text=%C2%A1Hola%21%20Quiero%20activar%20mi%20web%20premium%20con%20WebsiteIA.%20%C2%BFMe%20asesoran%3F" className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-gradient-to-r from-electric to-neon rounded-full" data-id="element-321">
            Activar mi web
          </a>
        </motion.div>}
    </motion.nav>;
}